import { useEffect, useState } from 'react';

/*
 * Canvas et inspecteur partagent ce module (même fenêtre JS) : un clic sur un
 * repère ou une étape du canvas ouvre l'entrée correspondante de la liste.
 */
const listeners = new Set();
// Le clic qui sélectionne la box monte l'inspecteur après lui : on garde la dernière demande un instant.
const PENDING_MS = 1000;
let pending = null;

export const revealListItem = (blockId, index) => {
  pending = { blockId, index, at: Date.now() };
  listeners.forEach((listener) => listener(blockId, index));
};

export function useListItemReveal(blockId) {
  const [reveal, setReveal] = useState(null);
  useEffect(() => {
    const listener = (id, index) => { if (id === blockId) setReveal({ index }); };
    if (pending?.blockId === blockId && Date.now() - pending.at < PENDING_MS) setReveal({ index: pending.index });
    listeners.add(listener);
    return () => { listeners.delete(listener); };
  }, [blockId]);
  return reveal;
}
